import { Flex, Text, FlexProps } from '@chakra-ui/react';
import React from 'react';
import { isAndroid, isFirefox } from 'react-device-detect';

export interface PlaceholderOverlayProps extends FlexProps {
	label: string;
}

const PlaceholderOverlay: React.FC<PlaceholderOverlayProps> = ({
	label,
	...props
}) => (
	<Flex
		position="absolute"
		rounded="5px"
		h="full"
		w="full"
		alignItems="center"
		pl={{ base: isFirefox ? '15px' : '37px' }}
		pb={isFirefox && isAndroid && label.includes('data') ? '.1rem' : ''}
		fontSize={{ base: isFirefox && isAndroid ? '11px' : '12px', sm: 'inherit' }}
		zIndex="10"
		{...props}>
		<Text bg="white" py={2} fontWeight={{ base: '500', lg: '400' }}>
			{label}
		</Text>
	</Flex>
);

export default PlaceholderOverlay;
